import { Scenes } from "../constants";

export const HeaderManagementMixin = {
  updateHeaderTitle() {
    const scene = this.currentSceneValue;
    let title = "";

    switch (scene) {
      case Scenes.TOP:
        title = "収穫金倉庫";
        break;
      case Scenes.PAYOUT_REQUEST_TOP:
      case Scenes.PAYOUT_REQUEST_CONFIRM:
        title = "出金申請";
        break;
      case Scenes.PAYOUT_REQUEST_HISTORY:
        title = "出金申請履歴";
        break;
      case Scenes.HARVEST_TOP:
        title = "収穫実績";
        break;
      case Scenes.HARVEST_HISTORY:
        title = "収穫残高履歴";
        break;
      case Scenes.HARVEST_ESTIMATED_RETURN:
        title = "収穫予定一覧";
        break;
      default:
        title = "収穫金倉庫";
    }

    this.headerTitleTarget.textContent = title;
  },
};
